module.exports = __webpack_public_path__ + "img/004李燚东.a0452f8b.jpg";